import { TRANSLATE_PREFIX } from '../../consts';
import { SERVER_SIDE_METHODS } from './consts';
import CategoryCell from './CategoryCell';
import FieldNameCell from './FieldNameCell';
import DescriptionCell from './DescriptionCell';
import SingularKeyCell from './SingularKeyCell';
import MacroCell from './MacroCell';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

export const isServerSideMethod = method => SERVER_SIDE_METHODS.includes(method);
// True iff the row is user-added (custom). Read from the persisted `is_custom` flag rather
// than guessing from `singular_key`, so a typed-in custom key that happens to collide with a
// STANDARD key is still correctly classified as custom.
export const isCustomParam = p => !!p?.is_custom;

export const getTableMetadata = ({ sharedCellProps, readOnly }) => [
    {
        name: 'category',
        displayName: `${TAB_PREFIX}.TABLE_CATEGORY`,
        cellComponent: CategoryCell,
        cellProps: { readOnly },
        headerWidth: 120,
    },
    {
        name: 'field_name',
        displayName: `${TAB_PREFIX}.TABLE_FIELD_NAME`,
        cellComponent: FieldNameCell,
        cellProps: sharedCellProps,
        headerWidth: 150,
    },
    {
        name: 'description',
        displayName: `${TAB_PREFIX}.TABLE_DESCRIPTION`,
        cellComponent: DescriptionCell,
        cellProps: sharedCellProps,
    },
    {
        name: 'singular_key',
        displayName: `${TAB_PREFIX}.TABLE_SINGULAR_KEY`,
        cellComponent: SingularKeyCell,
        cellProps: sharedCellProps,
        headerWidth: 250,
    },
    {
        name: 'partner_macro',
        displayName: `${TAB_PREFIX}.TABLE_YOUR_MACRO`,
        cellComponent: MacroCell,
        cellProps: sharedCellProps,
        headerWidth: 250,
    },
];
